<template>
  <Page>
    <template #title>Включение ЛМСЗ в жизненную ситуацию</template>

    <LMSPForm />
  </Page>
</template>

<script>
  import Page from '@/components/layouts/main/page/index';
  import LMSPForm from '@/components/views/lmsp/form/index';

  export default {
    name: 'LMSPRequestPage',

    components: {
      Page,
      LMSPForm,
    },
  };
</script>
